exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".app-field-chip__x{display:none;-webkit-margin-start:5px;margin-inline-start:5px;font-weight:700;cursor:pointer;opacity:.6}.app-field-chip:hover .app-field-chip__x{display:inline}.app-field-chip__x:hover{opacity:1}", ""]);

// exports
